// extracted by mini-css-extract-plugin
export default {"form":"WtKGs","token":"Vl_4W","fieldWrap":"EvIN9","buttonWrap":"JUfvj"};